import { useFeatureIsOn } from '@monofront/business/contexts';
import { FEATURE_FLAG_COBBAI_CHATBOT } from '@monofront/business/constants/featureFlags';
import {
  FORCE_PAGES_TO_KEEP_FOR_CHATBOT,
  PAGES_TO_EXCLUDE_FOR_CHATBOT,
  PAGES_TO_EXCLUDE_FOR_CHATBOT_ON_MOBILE_ONLY,
} from '@constants/chatbot';
import useI18n from '@hooks/i18n/useI18n';
import { useMediaQuery } from '@monofront/business/hooks';
import { isMobileApp } from '@utils/environment';
import { useRouter } from 'next/router';

const useIsCobbaiEnabled = (): boolean => {
  const feature = useFeatureIsOn(FEATURE_FLAG_COBBAI_CHATBOT);
  const { isFrenchMarket } = useI18n();
  const router = useRouter();
  const isMobileWebsite = useMediaQuery(800);

  const hidePage =
    (!FORCE_PAGES_TO_KEEP_FOR_CHATBOT.includes(router.asPath) &&
      PAGES_TO_EXCLUDE_FOR_CHATBOT.includes(router.pathname)) ||
    PAGES_TO_EXCLUDE_FOR_CHATBOT.includes(router.asPath) ||
    (isMobileWebsite &&
      PAGES_TO_EXCLUDE_FOR_CHATBOT_ON_MOBILE_ONLY.includes(router.pathname));

  return isFrenchMarket && !isMobileApp && feature && !hidePage;
};

export default useIsCobbaiEnabled;
